import React, { Component } from "react";
import EDDSL from "@geistinteractive/edd";
import { DeviceUUID } from "device-uuid";

class EDDLicenseActivator extends Component {
  constructor(props) {
    super(props);
    //storing a deviceID locally
    let chain = localStorage.getItem("gi-gd-chain");
    if (!chain) {
      let chain = new DeviceUUID().get();
      localStorage.setItem("gi-gd-chain", chain);
    }
    //we start the app activated, but the request fires off to check the activation
    // later it will return and change this state as needed
    this.state = {
      activated: true,
      activationChecked: false
    };
  }

  /**
   * finally we check the license on the server and activate it
   */
  async checkActivation() {
    const { eddItemId } = this.props;
    const chain = localStorage.getItem("gi-gd-chain");
    const name = localStorage.getItem("gi-gd-name");
    const license = localStorage.getItem("gi-gd-license");
    const activationId = name + "-" + chain;
    const eddsl = new EDDSL("https://edd-sl-proxy.geistgate.com");
    const checkResult = await eddsl.licenseCheck(
      license,
      eddItemId,
      activationId
    );

    if (checkResult.license === "site_inactive") {
      checkResult.license = "inactive";
    }

    if (checkResult.license === "valid") {
      return { activated: true };
    }
    if (
      checkResult.license === "inactive" &&
      checkResult.activations_left === 0
    ) {
      return {
        activated: false,
        reason: "no more activations left"
      };
    } else if (checkResult.license === "inactive") {
      const activationResult = await eddsl.licenseActivate(
        license,
        eddItemId,
        activationId
      );
      if (activationResult.license === "valid") {
        return { activated: true };
      }
    } else {
      return {
        actitvated: false,
        reason: checkResult.license
      };
    }
  }

  /**
   * attempt the activation if there is a license
   * store the state
   */
  tryToActivate() {
    const license = localStorage.getItem("gi-gd-license");

    if (license) {
      this.checkActivation()
        .then(result => {
          const newState = {
            activationChecked: true,
            activated: result.activated ? true : false,
            reason: result.reason
          };

          this.setState(newState);
        })
        .catch(e => {
          console.log("error", e);
        });
    } else {
      this.setState({ activated: false, reason: "need to install license" });
    }
  }

  /**
   * this method is exposed to the api
   * installs the license if there has been a change
   */
  activateLicense = ({ license, activationName }) => {
    const oldName = localStorage.getItem("gi-gd-name");
    const oldLicense = localStorage.getItem("gi-gd-license");
    if (oldName + oldLicense !== activationName + license) {
      localStorage.setItem("gi-gd-license", license);
      localStorage.setItem("gi-gd-name", activationName);
      this.tryToActivate();
    }
    return "activating";
  };

  async deactivateLicense() {
    const { eddItemId } = this.props;
    const chain = localStorage.getItem("gi-gd-chain");
    const name = localStorage.getItem("gi-gd-name");
    const license = localStorage.getItem("gi-gd-license");
    const activationId = name + "-" + chain;
    const eddsl = new EDDSL("https://edd-sl-proxy.geistgate.com");
    try {
      await eddsl.licenseDeactivate(license, eddItemId, activationId);
      localStorage.removeItem("gi-gd-license");
      localStorage.removeItem("gi-gd-name");
      this.tryToActivate();
      return true;
    } catch (e) {
      return false;
    }
  }

  componentWillMount() {
    // expose methods to the API
    const { exposeMethods } = this.props;
    exposeMethods({
      activateLicense: this.activateLicense,
      deactivateLicense: this.deactivateLicense.bind(this)
    });
  }

  render() {
    const { activated, reason } = this.state;

    const { LicensedApp, exposeMethods, callFMScript } = this.props;

    return (
      <div>
        <LicensedApp
          activated={activated}
          reason={reason}
          exposeMethods={exposeMethods}
          callFMScript={callFMScript}
        />
      </div>
    );
  }
}

export default EDDLicenseActivator;



// WEBPACK FOOTER //
// ./src/components/EDDLicenseActivator.js